<!-- Filtro avanzado flotante superior -->
<app-advanced-filter #advFilter [fields]="advancedFilterFields" [showTrigger]="false"
    (filtersChange)="onAdvancedFiltersChange($event)">
</app-advanced-filter>

<!-- Cabecera estandarizada responsive -->
<app-page-header
    title="Gestión de Pagos"
    mobileTitle="Pagos"
    icon="fas fa-hand-holding-usd"
    optionsLabel="Opciones"
    optionsIcon="fa fa-cog"
    [hasOptions]="true">
    <div headerOptions>
        @if (perm.hasCurrentAction('EXPORT_EXCEL')) {
        <a (click)="exportExcel()" class="dropdown-item">
            <i class="fa fa-file-excel fa-fw me-2 text-success"></i> Exportar Cartola Excel
        </a>
        }
        @if (perm.hasCurrentAction('ACCOUNT_PAYMENTS_UCH')) {
        <div role="separator" class="dropdown-divider"></div>
        <a (click)="openPaymentExportModal(paymentExportModal)" class="dropdown-item">
            <i class="fas fa-file-invoice-dollar fa-fw me-2 text-primary"></i> Aasinet - Pagos Entidades
        </a>
        }
        @if (perm.hasCurrentAction('ACCOUNT_BILLING_UCH')) {
        <a (click)="openEntityBillingModal(entityExportModal)" class="dropdown-item">
            <i class="fas fa-university fa-fw me-2 text-info"></i> Aasinet - Cobros Entidades
        </a>
        }
        @if (perm.hasCurrentAction('ADJUSTMENT_UCH')) {
        <div role="separator" class="dropdown-divider"></div>
        <a (click)="openRegisterPayment('ADJUSTMENT')" class="dropdown-item">
            <i class="fas fa-sliders-h fa-fw me-2 text-warning"></i> Registrar Ajuste Contable
        </a>
        }
    </div>
</app-page-header>

<app-mobile-footer [visible]="appSettings.isMobile()">
    <ng-select [items]="movementTypes" bindLabel="name" bindValue="code"
        class="mobile-footer-search"
        [(ngModel)]="movementTypeFilter" (change)="filterMovements()"
        [clearable]="false"
        [dropdownPosition]="'top'"
        placeholder="Tipo de movimiento">
    </ng-select>
    <button type="button" class="btn btn-outline-secondary btn-sm mobile-footer-filter"
        [class.btn-outline-primary]="advFilter.activeFiltersCount() > 0"
        (click)="advFilter.toggleOpen()">
        <i class="fas fa-filter me-1"></i>Filtros
        @if (advFilter.activeFiltersCount() > 0) {
            <span class="badge bg-primary ms-1">{{ advFilter.activeFiltersCount() }}</span>
        }
    </button>
</app-mobile-footer>

<!-- Mini Dashboard Contable -->
@if(!isLoading && movements.length > 0) {
    @if (!appSettings.isMobile()) {
        <!-- Mini Dashboard Desktop -->
        <div class="row mb-3">
            <div class="col-xl-4">
                <div class="panel h-100 border-0 shadow-sm">
                    <div class="panel-body p-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 class="text-muted small text-uppercase fw-bold mb-1">
                                    <i class="fa fa-arrow-up text-success me-1"></i> Total Pagos (Abonos)
                                </h5>
                                <h3 class="mb-0 fw-bold">${{ totalIngresos | number:'1.0-0':'es-CL' }}</h3>
                            </div>
                            <div class="text-success opacity-25">
                                <i class="fas fa-hand-holding-usd fa-3x"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-4">
                <div class="panel h-100 border-0 shadow-sm">
                    <div class="panel-body p-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 class="text-muted small text-uppercase fw-bold mb-1">
                                    <i class="fa fa-arrow-down text-danger me-1"></i> Total Cobros (Deuda)
                                </h5>
                                <h3 class="mb-0 fw-bold">${{ totalEgresos | number:'1.0-0':'es-CL' }}</h3>
                            </div>
                            <div class="text-danger opacity-25">
                                <i class="fas fa-file-invoice-dollar fa-3x"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-xl-4">
                <div class="panel h-100 border-0 shadow-sm">
                    <div class="panel-body p-3">
                        <div class="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 class="text-muted small text-uppercase fw-bold mb-1">
                                    <i class="fa fa-equals text-primary me-1"></i> Saldo Pendiente
                                </h5>
                                <h3 class="mb-0 fw-bold">
                                    ${{ totalMargen | number:'1.0-0':'es-CL' }}
                                </h3>
                            </div>
                            <div class="text-primary opacity-25">
                                <i class="fas fa-balance-scale fa-3x"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    } @else {
        <!-- Mini Dashboard Movil -->
        <div class="row g-2 mb-2">
            <div class="col-4">
                <div class="card border-0 shadow-sm p-2 text-center">
                    <span class="text-muted fw-bold" style="font-size: 10px;">PAGOS</span>
                    <span class="fw-bold text-success font-monospace" style="font-size: 11px;">${{ totalIngresos | number:'1.0-0':'es-CL' }}</span>
                </div>
            </div>
            <div class="col-4">
                <div class="card border-0 shadow-sm p-2 text-center">
                    <span class="text-muted fw-bold" style="font-size: 10px;">COBROS</span>
                    <span class="fw-bold text-danger font-monospace" style="font-size: 11px;">${{ totalEgresos | number:'1.0-0':'es-CL' }}</span>
                </div>
            </div>
            <div class="col-4">
                <div class="card border-0 shadow-sm p-2 text-center">
                    <span class="text-muted fw-bold" style="font-size: 10px;">SALDO</span>
                    <span class="fw-bold text-primary font-monospace" style="font-size: 11px;">${{ totalMargen | number:'1.0-0':'es-CL' }}</span>
                </div>
            </div>
        </div>
    }
}

@if (!appSettings.isMobile()) {
    <!-- Panel de Filtros Desktop -->
    <div class="panel p-3 mb-3 border-0 shadow-sm position-relative">
        <div class="row align-items-end g-3">
            <div class="col-md-2">
                <label class="form-label fw-bold small text-uppercase text-muted">Periodo Desde</label>
                <ng-select [items]="periods" bindLabel="displayName" bindValue="id" [(ngModel)]="selectedPeriodStartId"
                    (change)="updateFilteredEndPeriods(); loadAnalysis()" [clearable]="false" placeholder="Desde">
                </ng-select>
            </div>
            <div class="col-md-2">
                <label class="form-label fw-bold small text-uppercase text-muted">Periodo Hasta</label>
                <ng-select [items]="filteredEndPeriods" bindLabel="displayName" bindValue="id"
                    [(ngModel)]="selectedPeriodEndId" (change)="loadAnalysis()" [clearable]="false" placeholder="Hasta">
                </ng-select>
            </div>
            <div class="col-md-3">
                <label class="form-label fw-bold small text-uppercase text-muted">Contabilización</label>
                <ng-select [items]="accountedFilters" bindLabel="name" bindValue="slug"
                    [(ngModel)]="selectedAccounted" (change)="filterMovements()" [clearable]="false"
                    placeholder="Contabilización">
                </ng-select>
            </div>
            <div class="col-md-3">
                <label class="form-label fw-bold small text-uppercase text-muted">Entidad</label>
                <ng-select [items]="entities" bindLabel="name" bindValue="code" [(ngModel)]="selectedEntityCode"
                    (change)="loadAnalysis()" [multiple]="true" [searchable]="true" [clearable]="true" placeholder="Todas las Entidades">
                </ng-select>
            </div>
            <div class="col-md-2">
                <label class="form-label fw-bold small text-uppercase text-muted">Tipo</label>
                <ng-select [items]="movementTypes" bindLabel="name" bindValue="code"
                    [(ngModel)]="movementTypeFilter" (change)="filterMovements()" [clearable]="false" placeholder="Todos">
                </ng-select>
            </div>
        </div>
    </div>
}

@if (!appSettings.isMobile()) {
    <!-- Tabla Desktop -->
    <div class="panel p-3 mb-3 border-0 shadow-sm">
        <div class="col-12 table-data mb-3">
            <table class="table table-sm table-hover">
                <thead>
                    <tr>
                        <th class="text-uppercase align-middle">
                            <div class="d-inline-flex align-items-center gap-1">
                                <button type="button" class="filter-table-btn" (click)="advFilter.toggleOpen()" title="Filtros avanzados">
                                    <i class="fas fa-filter" [class.text-primary]="advFilter.activeFiltersCount() > 0"></i>
                                    @if(advFilter.activeFiltersCount() > 0) {
                                        <span class="filter-count-badge">{{ advFilter.activeFiltersCount() }}</span>
                                    }
                                </button>
                                <span>Entidad</span>
                            </div>
                        </th>
                        <th class="text-uppercase">Estado</th>
                        <th class="text-uppercase">Fecha</th>
                        <th class="text-uppercase">Tipo</th>
                        <th class="text-uppercase">Descripción</th>
                        <th class="text-end text-uppercase">Cargo (Cobro)</th>
                        <th class="text-end text-uppercase">Abono (Pago)</th>
                        <th class="text-end text-uppercase">Saldo</th>
                        <th class="text-end text-uppercase" style="width: 70px;"></th>
                    </tr>
                </thead>
                <tbody>
                    @if(isLoading) {
                    @for(i of [1,2,3,4,5,6]; track $index) {
                    <tr class="placeholder-glow">
                        <td class="align-middle"><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></td>
                        <td class="align-middle text-center"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                        <td class="align-middle"><span class="placeholder placeholder-sm col-6 bg-gray-500"></span></td>
                        <td class="align-middle"><span class="placeholder placeholder-sm col-5 bg-gray-500"></span></td>
                        <td class="align-middle"><span class="placeholder placeholder-sm col-10 bg-gray-500"></span></td>
                        <td class="align-middle text-end"><span class="placeholder placeholder-sm col-7 bg-gray-500"></span></td>
                        <td class="align-middle text-end"><span class="placeholder placeholder-sm col-7 bg-gray-500"></span></td>
                        <td class="align-middle text-end"><span class="placeholder placeholder-sm col-8 bg-gray-500"></span></td>
                        <td class="align-middle text-end"><span class="placeholder placeholder-sm col-4 bg-gray-500"></span></td>
                    </tr>
                    }
                    } @else {
                    @for(move of movements; track $index) {
                    <tr>                        
                        <td class="align-middle">{{ move.entityCode ?? 'General' }}</td>
                        <td class="text-center align-middle">
                            @if(isMovementAccounted(move)) {
                                <span class="badge bg-success" [title]="move.accountedAt || ''">Contabilizado</span>
                            } @else if(isMovementAccounted(move) === false) {
                                <span class="badge bg-secondary">Pendiente</span>
                            } @else {
                                <span class="text-muted">—</span>
                            }
                        </td>
                        <td class="align-middle">{{ move.date | date:'dd/MM/yyyy' }}</td>
                        <td class="align-middle">
                            <span class="badge border" [ngClass]="move.type === 'COBRO' ? 'border-danger text-danger' : 'border-success text-success'">
                                {{ move.type }}
                            </span>
                        </td>
                        <td class="align-middle">{{ move.description }}</td>
                        <td class="text-end align-middle">
                            {{ move.charge > 0 ? (move.charge | number:'1.0-0':'es-CL') : '-' }}
                        </td>
                        <td class="text-end align-middle">
                            {{ move.credit > 0 ? (move.credit | number:'1.0-0':'es-CL') : '-' }}
                        </td>
                        <td class="text-end align-middle fw-bold">
                            ${{ move.balance | number:'1.0-0':'es-CL' }}
                        </td>
                        <td class="text-end align-middle">
                            @if (hasReceipt(move)) {
                                <button type="button" class="btn btn-xs btn-outline-info"
                                    (click)="viewReceipt(move, receiptPreview)"
                                    title="Ver / descargar comprobante">
                                    <i class="fas fa-eye"></i>
                                </button>
                            }
                        </td>
                    </tr>
                    }
                    }

                    @if(!isLoading && hasLoadedData && movements.length === 0) {
                    <tr>
                        <td colspan="9" class="text-center p-5">
                            <div class="py-5">
                                <i class="fas fa-file-invoice-dollar fa-4x text-light mb-3"></i>
                                <h4 class="text-muted fw-normal">No hay movimientos registrados</h4>
                                <p class="text-muted small mb-0">Seleccione una entidad o cambie el rango de periodos.</p>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
                <tfoot>
                    @if(!isLoading && movements.length > 0) {
                    <tr>
                        <td colspan="8" class="text-end fw-bold">SALDO TOTAL DEUDA:</td>
                        <td class="text-end fw-bold">${{ getTotalBalance() | number:'1.0-0':'es-CL' }}</td>
                    </tr>
                    }
                </tfoot>
            </table>
        </div>
    </div>
} @else {
    <!-- Vista Movil: Tarjetas ListCard -->
    <div class="col-12 mobile-payment-container">
        <!-- Barra de cabecera movil -->
        <div class="d-flex justify-content-between align-items-center mb-2 px-1">
            <span class="small text-muted fw-bold text-uppercase">
                Movimientos @if(!isLoading) { ({{ movements.length }}) }
            </span>
            @if (!isLoading && movements.length > 0) {
                <span class="small fw-bold font-monospace">${{ getTotalBalance() | number:'1.0-0':'es-CL' }}</span>
            }
        </div>

        <!-- Contenedor con scroll para tarjetas -->
        <div class="mobile-cards-scroll">
            @if(isLoading) {
                @for(i of [1,2,3,4]; track $index) {
                    <app-list-card [isLoading]="true"></app-list-card>
                }
            } @else {
                @for(move of movements; track $index) {
                    <app-list-card>
                        <div cardTitle class="fw-bold text-dark text-truncate">
                            {{ move.description || 'Sin descripción' }}
                        </div>
                        <div cardBadge>
                            <span class="badge border" [ngClass]="move.type === 'COBRO' ? 'border-danger text-danger' : 'border-success text-success'">
                                {{ move.type }}
                            </span>
                            <span class="badge bg-light text-dark border ms-1">{{ move.entityCode ?? 'General' }}</span>
                        </div>

                        <div class="row g-1">
                            <div class="col-6">
                                <i class="fa fa-calendar me-1 text-muted"></i>
                                <span>{{ move.date | date:'dd/MM/yyyy' }}</span>
                            </div>
                            <div class="col-6 text-end">
                                @if(move.charge > 0) {
                                    <span class="text-danger fw-semibold">Cobro: ${{ move.charge | number:'1.0-0':'es-CL' }}</span>
                                } @else if(move.credit > 0) {
                                    <span class="text-success fw-semibold">Abono: ${{ move.credit | number:'1.0-0':'es-CL' }}</span>
                                } @else {
                                    <span class="text-muted">-</span>
                                }
                            </div>
                            @if(isMovementAccounted(move)) {
                                <div class="col-12 mt-1">
                                    <span class="badge border bg-light text-success border-success" [title]="move.accountedAt || ''">Contabilizado</span>
                                </div>
                            }
                        </div>

                        <div cardExtra>
                            <span class="text-muted text-uppercase fw-bold" style="font-size: 11px;">Saldo</span>
                        </div>
                        <div cardAmount class="fw-bold font-monospace fs-14">
                            ${{ move.balance | number:'1.0-0':'es-CL' }}
                        </div>
                        @if (hasReceipt(move)) {
                            <div cardActionsRow>
                                <button type="button" class="btn btn-xs btn-outline-info w-100"
                                    (click)="viewReceipt(move, receiptPreview)">
                                    <i class="fas fa-eye me-1"></i> Ver comprobante
                                </button>
                            </div>
                        }
                    </app-list-card>
                }

                @if(hasLoadedData && movements.length === 0) {
                    <div class="card border-0 shadow-sm p-4 text-center">
                        <i class="fas fa-file-invoice-dollar fa-3x text-muted opacity-50 mb-2"></i>
                        <h6 class="text-muted mb-1">No hay movimientos registrados</h6>
                        <small class="text-muted">Ajusta los filtros o selecciona otra entidad.</small>
                    </div>
                }
            }
        </div>

    </div>
}


    <!-- Modal de Exportación y Contabilización de Pagos ASINET -->
    <ng-template #paymentExportModal let-c="close" let-d="dismiss" let-modal>
        <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-hand-holding-usd me-2"></i> Exportar y Contabilizar Pagos de Entidades</h5>
            <button type="button" class="btn-close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="alert alert-info d-flex align-items-center mb-3 py-2 px-3">
                <i class="fas fa-info-circle me-2"></i>
                <div>Marcá abonos para <strong>contabilizar</strong>. Los ya contabilizados se pueden re-exportar como <strong>copia</strong> ASINET.</div>
            </div>

            <div class="mb-3">
                <label class="form-label small text-muted mb-1">Periodo cerrado</label>
                <ng-select
                    [items]="closedPeriods()"
                    bindLabel="displayName"
                    bindValue="id"
                    [ngModel]="asinetPeriodId()"
                    (ngModelChange)="onAsinetPeriodChange($event)"
                    [clearable]="false"
                    placeholder="Seleccione periodo cerrado">
                </ng-select>
            </div>

            @if(isPaymentExportLoading()) {
                <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Cargando...</span>
                    </div>
                    <p class="text-muted small mt-2">Cargando abonos del periodo...</p>
                </div>
            } @else {
                <div class="table-responsive">
                    <table class="table table-sm table-hover align-middle mb-0">
                        <thead class="table-light">
                            <tr>
                                <th style="width: 40px;" class="text-center">
                                    <input type="checkbox"
                                        [checked]="allPendingSelected()"
                                        [disabled]="!hasPendingAsinetPayments()"
                                        (change)="toggleSelectAllPending($any($event.target).checked)"
                                        title="Seleccionar pendientes">
                                </th>
                                <th style="width: 110px;">Fecha</th>
                                <th style="width: 90px;">Código</th>
                                <th>Entidad</th>
                                <th>Glosa / Descripción</th>
                                <th class="text-center" style="width: 120px;">Contabilizado</th>
                                <th class="text-end" style="width: 140px;">Monto Abonado</th>
                                <th class="text-end" style="width: 56px;"></th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(p of asinetPayments(); track p.uuid) {
                            <tr [class.table-light]="p.isAccounted">
                                <td class="text-center">
                                    <input type="checkbox"
                                        [checked]="isPaymentSelected(p.uuid)"
                                        (change)="togglePaymentSelection(p.uuid, $any($event.target).checked)">
                                </td>
                                <td>{{ p.date | date:'dd/MM/yyyy' }}</td>
                                <td><span class="badge bg-light text-dark border">{{ p.entityCode }}</span></td>
                                <td class="fw-semibold">{{ getEntityName(p.entityCode) }}</td>
                                <td>{{ p.description }}</td>
                                <td class="text-center">
                                    @if(p.isAccounted) {
                                        <span class="badge bg-success" [title]="p.accountedAt || ''">Contabilizado</span>
                                    } @else {
                                        <span class="badge bg-secondary">No</span>
                                    }
                                </td>
                                <td class="text-end fw-semibold text-success">${{ p.credit | number:'1.0-0':'es-CL' }}</td>
                                <td class="text-end">
                                    @if (hasReceipt(p)) {
                                        <button type="button" class="btn btn-xs btn-outline-info"
                                            (click)="viewReceipt(p, receiptPreview)"
                                            title="Ver / descargar comprobante">
                                            <i class="fas fa-eye"></i>
                                        </button>
                                    }
                                </td>
                            </tr>
                            }
                            @if(asinetPayments().length === 0) {
                            <tr>
                                <td colspan="8" class="text-center text-muted py-3">No hay abonos de entidades en este periodo.</td>
                            </tr>
                            }
                        </tbody>
                        @if(asinetPayments().length > 0) {
                        <tfoot class="table-light fw-bold">
                            <tr>
                                <td colspan="7" class="text-uppercase text-muted small">
                                    Selección: {{ selectedAsinetPayments().length }}
                                    @if(selectedPendingPayments().length) {
                                        <span class="ms-2">({{ selectedPendingPayments().length }} pendiente(s) · ${{ selectedPendingTotal() | number:'1.0-0':'es-CL' }})</span>
                                    }
                                </td>
                                <td class="text-end text-success fs-6">${{ selectedPaymentsTotal() | number:'1.0-0':'es-CL' }}</td>
                            </tr>
                        </tfoot>
                        }
                    </table>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary" (click)="d('Cancel')">Cerrar</button>
            @if (perm.hasCurrentAction('EXPORT_EXCEL')) {
            <button class="btn btn-primary"
                [disabled]="selectedAsinetPayments().length === 0 || isPaymentExportLoading()"
                (click)="exportPaymentsOnly(modal)">
                <i class="fas fa-download me-1"></i> Exportar Excel (Copia)
            </button>
            }
            @if (perm.hasCurrentAction('ACCOUNT_PAYMENTS_UCH')) {
            <button class="btn btn-success"
                [disabled]="selectedPendingPayments().length === 0 || isPaymentExportLoading()"
                (click)="exportAndAccountPayments(modal)">
                <i class="fas fa-file-excel me-1"></i> Exportar y Contabilizar
            </button>
            }
        </div>
    </ng-template>

    <!-- Modal Cobro Consolidado por Entidades ASINET -->
    <ng-template #entityExportModal let-c="close" let-d="dismiss" let-modal>
        <div class="modal-header">
            <h5 class="modal-title"><i class="fas fa-building me-2"></i> Cobro Consolidado por Entidades</h5>
            <button type="button" class="btn-close" (click)="d('Cross click')"></button>
        </div>
        <div class="modal-body">
            <div class="mb-3">
                <label class="form-label small text-muted mb-1">Periodo cerrado</label>
                <ng-select
                    [items]="closedPeriods()"
                    bindLabel="displayName"
                    bindValue="id"
                    [ngModel]="asinetPeriodId()"
                    (ngModelChange)="onAsinetEntityPeriodChange($event)"
                    [clearable]="false"
                    placeholder="Seleccione periodo cerrado">
                </ng-select>
            </div>

            @if(asinetPeriod()?.isEntityAccounted) {
                <div class="alert alert-success d-flex align-items-center mb-3 py-2 px-3">
                    <i class="fas fa-check-circle me-2"></i>
                    <div><strong>Contabilizado:</strong> El cobro a entidades fue contabilizado el {{ entityAccountedInfo()?.date }} por {{ entityAccountedInfo()?.user }}.</div>
                </div>
            } @else {
                <div class="alert alert-info d-flex align-items-center mb-3 py-2 px-3">
                    <i class="fas fa-info-circle me-2"></i>
                    <div>Periodo cerrado. Puede proceder a exportar y marcar como contabilizado en ASINET.</div>
                </div>
            }

            @if(isEntityBillingLoading()) {
                <div class="text-center py-4">
                    <div class="spinner-border text-primary" role="status">
                        <span class="visually-hidden">Cargando...</span>
                    </div>
                    <p class="text-muted small mt-2">Cargando cobros por entidad...</p>
                </div>
            } @else {
                <div class="table-responsive">
                    <table class="table table-sm table-hover align-middle mb-0">
                        <thead class="table-light">
                            <tr>
                                <th style="width: 120px;">Código</th>
                                <th>Nombre de Entidad</th>
                                <th class="text-end" style="width: 180px;">Monto</th>
                            </tr>
                        </thead>
                        <tbody>
                            @for(item of entityBillingItems(); track item.entityCode) {
                            <tr>
                                <td class="fw-bold">{{ item.entityCode }}</td>
                                <td>{{ item.entityName }}</td>
                                <td class="text-end fw-semibold">${{ item.amount | number:'1.0-0':'es-CL' }}</td>
                            </tr>
                            }
                            @if(entityBillingItems().length === 0) {
                            <tr>
                                <td colspan="3" class="text-center text-muted py-3">No hay cobros de entidades para este periodo.</td>
                            </tr>
                            }
                        </tbody>
                        @if(entityBillingItems().length > 0) {
                        <tfoot class="table-light fw-bold">
                            <tr>
                                <td colspan="2" class="text-uppercase text-muted">Total General Periodo</td>
                                <td class="text-end text-primary fs-6">${{ entityBillingTotal() | number:'1.0-0':'es-CL' }}</td>
                            </tr>
                        </tfoot>
                        }
                    </table>
                </div>
            }
        </div>
        <div class="modal-footer">
            <button class="btn btn-secondary" (click)="d('Cancel')">Cerrar</button>
            @if (perm.hasCurrentAction('EXPORT_EXCEL')) {
                <button class="btn btn-primary" [disabled]="entityBillingItems().length === 0" (click)="exportEntitiesOnly(modal)">
                    <i class="fas fa-download me-1"></i> Exportar Excel (Copia)
                </button>
            }
            @if (perm.hasCurrentAction('ACCOUNT_BILLING_UCH') && !asinetPeriod()?.isEntityAccounted) {
                <button class="btn btn-success" [disabled]="entityBillingItems().length === 0 || isEntityBillingLoading()" (click)="exportAndAccountEntities(modal)">
                    <i class="fas fa-file-excel me-1"></i> Exportar y Contabilizar
                </button>
            }
        </div>
    </ng-template>

    <!-- Modal vista previa / descarga del comprobante de abono -->
    <ng-template #receiptPreview let-c="close" let-d="dismiss">
        <div class="modal-header">
            <h4 class="modal-title">Comprobante de pago</h4>
            <div class="ms-auto d-flex align-items-center flex-wrap gap-2">
                @if (perm.hasCurrentAction('EXPORT_PDF')) {
                <a [href]="previewRawUrl"
                    class="btn btn-success btn-sm"
                    target="_blank"
                    [attr.download]="previewFileName || 'comprobante'">
                    <i class="fas fa-download me-1"></i> Descargar / Abrir
                </a>
                }
                <button type="button" class="btn-close" (click)="d('Cross click')"></button>
            </div>
        </div>
        <div class="modal-body p-0 text-center bg-light">
            @if (previewType === 'pdf' && pdfSrc) {
                <iframe [src]="pdfSrc" width="100%" height="750px" style="border: none;"></iframe>
            }
            @if (previewType === 'image' && imgSrc) {
                <div class="p-3">
                    <img [src]="imgSrc" class="img-fluid rounded border shadow-sm"
                        style="max-height: 730px; object-fit: contain;"
                        [alt]="previewFileName || 'Comprobante'">
                </div>
            }
        </div>
    </ng-template>
